import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M.762 15.914h14.804a.2.2 0 100-.399H.761a.2.2 0 100 .399zM12.922 10.093L8.165 14.85l-4.758-4.758h-.284v.284l4.9 4.899.143.058.14-.058 4.902-4.9v-.283h-.285z" fill="currentcolor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.963 1.133v14c0 .109.09.2.2.2.11 0 .2-.091.2-.2V1.133a.202.202 0 00-.2-.201c-.11 0-.2.09-.2.202z" fill="currentcolor"/></svg>`;

export { symbol as default };
